<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Medical Exam Status</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="form" #f="ngForm" autocomplete="off" *ngIf="displayResults">
        <fieldset>
            <div class="row">
                <div class="col-sm-8 mvd_form-group">
                    <label class="required" title="* Required" for="state">MEC Status</label>
                    <select class="mvd_form-control" id="certificateStatus" name="certificateStatus" formControlName="certificateStatus">
                        <option></option>
                        <option *ngFor="let s of getCertificateStatuses()" [value]="s.id">{{ s.displayValue }}</option>
                    </select>
                    <control-validation-messages control="certificateStatus"></control-validation-messages>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group" *ngIf="displayResults">
        <button (click)="cancel()" class="btn--default" type="button">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!form?.valid || disableSave" [isLoading]="showButtonLoading" btnText="Save" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>